import { render, staticRenderFns } from "./CustomerDetailInvoices.vue?vue&type=template&id=1ff45821"
import script from "./CustomerDetailInvoices.vue?vue&type=script&lang=js"
export * from "./CustomerDetailInvoices.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailInvoices.vue?vue&type=style&index=0&id=1ff45821&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports